var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{attrs:{"id":"palette"}},_vm._l((_vm.colors),function(color){return _c('span',{key:color,class:[_vm.isSelected(color) && 'selected', 'color', _vm.colorClass(color)],on:{"click":function($event){return _vm.colorSelected(color)}}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }